var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAudio = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.5 8.516V8.28c0-.58.39-1.054.947-1.195l6.82-1.823a.782.782 0 0 1 .983.753v.86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.25 11.559v3.125c0 .543-.349 1-.86 1.171l-.859.313c-1.011.34-2.031-.407-2.031-1.484a1.3 1.3 0 0 1 .898-1.25l1.993-.71c.51-.171.859-.622.859-1.165m0 0V2.264a.392.392 0 0 0-.492-.375l-7.79 2.094a.644.644 0 0 0-.468.625v8.828c0 .543-.349 1-.86 1.172l-2.03.703c-.543.183-.86.672-.86 1.25 0 1.077 1.036 1.818 2.031 1.484l.86-.312c.51-.172.859-.628.859-1.172v-3.125"
  })));
};
export { SvgAudio as ReactComponent };